import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Coloring pages with no therapeutic purpose', 'Ice-breakers that end when the drawing does', 'No processing questions: you improvise them', 'Mostly for young kids, one-to-one only', 'You still decide what to run on Monday'];
const withIt = ['A complete session for every week, in order', 'Processing questions written for all 52 sessions', 'Individual, group and online versions', 'Kids, teens and adults, with common materials', 'Open the week and run it'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-353" data-mp="297qovf0g6w2z">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:py-20" data-id="element-354" data-mp="295e7p42ikpqz">
        <div className="text-center" data-id="element-355" data-mp="2d799sas9r75t">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-356" data-mp="30yeounqdxvf2">Why this isn&apos;t another worksheet bundle</p>
          <h2 id="vs-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-357" data-mp="35ov2a7u7hh1f">
            Worksheets vs <span className="wash-text" data-id="element-358" data-mp="1teldalrub6m9">complete sessions</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-359" data-mp="1ogjt1xioh197">
            Most packs for therapists sell volume: 200+ worksheets, coloring
            pages, ice-breakers. Volume was never the hard part. Knowing what to
            run this week, and what to ask once the art is done, was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl shadow-card" data-id="element-360" data-mp="2849eln00u59z">
          <div className="bg-paper px-3.5 py-4 sm:p-6" data-id="element-361" data-mp="286lt1q6klxia">
            <h3 className="font-display text-base font-semibold text-navy-muted sm:text-xl" data-id="element-362" data-mp="2m2z7srjpzkt2">
              A worksheet bundle or an ideas book
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-363" data-mp="rprbswk0d35u">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-navy-soft sm:text-sm" data-id="element-364" data-mp="mqwjn405i292">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-rose-soft" data-id="element-365" data-mp="2mtpb678tqr5i">
                    <XIcon className="h-2.5 w-2.5 text-rose-deep" aria-hidden="true" data-id="element-366" data-mp="2rtaawjvtj3ja" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-teal-soft px-3.5 py-4 sm:p-6" data-id="element-367" data-mp="30tqdlr4qm6n3">
            <h3 className="font-display text-base font-semibold text-teal-deep sm:text-xl" data-id="element-368" data-mp="35s9zjrjbzifg">
              52 Weeks of Art-Based Sessions
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-369" data-mp="3apjvlq186sc9">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug text-navy sm:text-sm" data-id="element-370" data-mp="3fj4qh97iv678">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white" data-id="element-371" data-mp="3jl9f1tj45cn0">
                    <CheckIcon className="h-2.5 w-2.5 text-teal-deep" aria-hidden="true" data-id="element-372" data-mp="3thm9wuqe9wjc" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}